import { MenuItemEditorTab } from "features/MenuItemEditor/types";

export const MENU_ITEM_EDITOR_TABS: { key: MenuItemEditorTab; label: string }[] = [
    { key: "main", label: "Основное" },
    { key: "photos", label: "Фотографии" },
    { key: "modifiers", label: "Модификаторы" },
    { key: "schedule", label: "Расписание" },
    { key: "extra", label: "Дополнительно" },
];

export const DEFAULT_MENU_ITEM_EDITOR_TAB: MenuItemEditorTab = "main";
